
/** Set to false to publish the digital menu again */
export const CARTA_UNDER_CONSTRUCTION = true;

export enum SegmentEnum {
    GeneralInformation = 'Informació General',
    Images = 'Images',
    Allergens = 'Al·lergens',
    Labels = 'Etiquetes',
    ProductsInformation = 'Productes',
    Weekdays = 'Dies de la setmana',
    SpecialRequirements = 'Requeriments Especials'
}